import { createTheme } from "@mui/material/styles";

export const defualtPrimaryColor = "#3E4094";
export const defualtPrimaryInfo = "#a9abd8";
export const secondaryColor = "#f2f2f2";
export const black = "#1E1E1E";
export const secondaryBlack = "#bebebe";
export const defaultBgLightWhite = "#FFFFFF";
export const defaultBgSuccess = "#219721";
export const defaultBgError = "#bd3030";
export const defaultBgLightError = "#df7171";
export const successPaymant = "#219721";
export const failurePaymant = "#bd3030";
export const cancelPaymant = "#bf3636";
export const panddingPaymant = "#c3c369";

export const lightTheme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: defualtPrimaryColor,
        },
        info: {
            main: defualtPrimaryInfo,
        },
        secondary: {
            main: secondaryColor,
        },
        error: {
            main: defaultBgError,
            light:defaultBgLightError,
        },
        success: {
            main: defaultBgSuccess,
        },
        bgBlack: {
            main: black,
        },
        bgLightBlack: {
            main: secondaryBlack,
        },
        bgLightWhite: {
            main: defaultBgLightWhite,
        },
        successPaymant: {
            main: successPaymant
        },
        failurePaymant: {
            main: failurePaymant
        },
        cancelPaymant: {
            main: cancelPaymant
        },
        panddingPaymant: {
            main: panddingPaymant
        },
    },
    typography: {
        fontFamily: "'Inter', sans-serif",
        button: {
            textTransform: "none",
        },
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableTouchRipple: true,
            },
        },

    },
});